module.exports = __webpack_public_path__ + "media/images/admin2/Filter__handle__wrapper__span-10cd1f98de81e658cda40944ff61f556.svg";